import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const UndoIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Undo`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M5.47 2.137a.75.75 0 0 1 1.06 1.06L4.477 5.25h5.19a4.42 4.42 0 0 1 4.417 4.417 4.419 4.419 0 0 1-4.417 4.416H7.334a.75.75 0 0 1 0-1.5h2.333a2.92 2.92 0 0 0 2.694-1.8 2.922 2.922 0 0 0 0-2.232A2.92 2.92 0 0 0 9.667 6.75h-5.19L6.53 8.804l.052.056a.75.75 0 0 1-1.055 1.055l-.057-.05L2.137 6.53a.75.75 0 0 1-.122-.167c-.015-.026-.03-.052-.042-.08-.005-.011-.007-.024-.011-.035A.745.745 0 0 1 1.917 6c0-.081.015-.158.04-.232.005-.016.008-.034.015-.05l.004-.01c.009-.022.02-.041.032-.062a.745.745 0 0 1 .129-.176L5.47 2.137Z"
    />
  </Icon>
);
